import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaCircle, FaUserCircle } from "react-icons/fa";
import { IoPeopleCircle } from "react-icons/io5";
import { useAuth } from "./AuthContext.tsx";
import { Dropdown } from "./widgets/Dropdown.tsx";
import { DropdownItem } from "./widgets/DropdownItem.tsx";

const Header: React.FC<{
  hasNotifications: boolean;
}> = ({ hasNotifications }: { hasNotifications: boolean }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = async () => {
    await logout();
  };

  const socialIconColor =
    location.pathname === "/social" ? "text-primary" : "text-gray-600";

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex justify-between items-end">
        <Link
          to="/"
          className="text-2xl font-bold text-gray-800 hover:text-gray-600"
          aria-label="Go to homepage"
        >
          <div className="flex flex-row items-center gap-2">
            <img
              src="/logo.png"
              alt="seriv.io logo"
              className="h-[1em] inline-block"
            />{" "}
            <span>
              seriv<span className="text-primary">.io</span>
            </span>
          </div>
        </Link>

        {user && (
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <p className="text-sm text-gray-500">Signed in as</p>
              <p className="text-sm font-medium text-gray-500">{user.email}</p>
            </div>
            <Dropdown
              trigger={
                <button
                  className="flex items-center gap-2 hover:opacity-80 transition-opacity"
                  aria-label="User menu"
                >
                  <FaUserCircle size={32} className="text-gray-600" />
                </button>
              }
              alignment="left"
            >
              <div className="px-4 py-2 border-b border-gray-200 sm:hidden">
                <p className="text-xs text-gray-500">Signed in as</p>
                <p className="text-sm font-medium text-gray-500">
                  {user.email}
                </p>
              </div>
              <DropdownItem onClick={() => navigate("/profile")}>
                Profile
              </DropdownItem>
              <DropdownItem onClick={handleSignOut}>
                <p className="text-danger">Sign out</p>
              </DropdownItem>
            </Dropdown>
            <button
              className={"relative ml-6 hover:opacity-80 transition-opacity"}
              onClick={() => navigate("/social")}
            >
              <IoPeopleCircle size={32} className={socialIconColor} />
              {hasNotifications && location.pathname !== "/social" && (
                <div className="absolute right-2 bottom-2 ">
                  <FaCircle
                    className="absolute text-primary animate-pulse"
                    size={10}
                  />
                  <FaCircle
                    className="absolute text-primary animate-ping"
                    size={10}
                  />
                </div>
              )}
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export { Header };
